import {
  OpenModalPayload,
  UnlockCompletePayload,
} from '@chegg-wt/core/state/modals/types'
import { SuperAuthIframeOrigin } from '@chegg-wt/core/components/Modals/SuperAuthIFrameModal/types'
import { AppRoute, AppRouteOpts } from '@chegg-wt/core/types/core'

export enum TitleIconFilenames {
  SAVE = 'save-disk.svg',
  CITE = 'citations.svg',
  LOCK = 'lock.svg',
}

export enum Titles {
  CREATE_ACCOUNT_STYLE = 'Create a free account to use this style',
  CREATE_ACCOUNT_CITATIONS = 'Create a free account to save your citations',
  KEEP_CITING = 'Keep citing uninterrupted',
}

export enum ButtonTexts {
  CREATE_ACCOUNT = 'Create account',
  CREATE_FREE_ACCOUNT = 'Create free account',
}

export enum UnlockLinkMessages {
  WATCH_PAID = 'Watch a paid message instead',
}

export enum UnlockCompleteActions {
  FORM_SUBMIT = 'form-submit',
}

export interface UnlockLinkProps {
  message: UnlockLinkMessages
  completionAction: UnlockCompleteActions
  alwaysParticipate?: boolean
}

export interface UnlockAccountGateModalData {
  origin: SuperAuthIframeOrigin
  titleIconFilename: TitleIconFilenames
  titleText: Titles
  createAccountButtonText: ButtonTexts
  canClose?: boolean
  fullMobileModal?: boolean
  maxWidth?: string
  unlock?: UnlockLinkProps
  shouldRedirectAuth?: boolean
  redirectRoute?: AppRoute
}

export interface UnlockAccountGateModalProps {
  closeModal: (name: string) => void
  openModal: (payload: OpenModalPayload) => void
  modalData: UnlockAccountGateModalData
  unlockActivityCompleted?: (payload: UnlockCompletePayload) => void
  userClickClose: (origin: SuperAuthIframeOrigin) => void
  userClickLogin: (origin: SuperAuthIframeOrigin) => void
  userClickCreateAccount: (origin: SuperAuthIframeOrigin) => void
  userClickUnlock: () => void
  navigated: (appRoute: AppRoute, opts?: AppRouteOpts) => void
  formSubmitStopped: () => void
  onVideoReady: () => void
}
